<template>
  <icon style="font-size: 8px">
    <template #component>
      <svg width="10" height="10" viewBox="0 0 10 10">
        <polygon points="5.9 4.5 5.9 0 4.1 0 4.1 4.5 0 4.5 5 10 10 4.5 5.9 4.5" />
      </svg>
    </template>
  </icon>
</template>

<script>
import Icon from "@ant-design/icons-vue";

export default {
  name: "ironIcon",
  components: { Icon }
};
</script>

<style scoped>

</style>